import {
  Badge,
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Center,
  CircularProgress,
  Flex,
  Heading,
  HStack,
  Link,
  LinkBox,
  LinkOverlay,
  Spinner,
  Stack,
  StackDivider,
  Tag,
  Text,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { apiEndPoint } from "./StaticVar";
import { useParams } from "react-router-dom";
import { pdfjs, Document, Page } from "react-pdf";
import { WorkerMessageHandler } from "pdfjs-dist/build/pdf.worker.min.mjs";
import { DownloadIcon } from "@chakra-ui/icons";
import MyLoading from "./MyLoading"
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  WorkerMessageHandler,
  import.meta.url
).toString();
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/5.3.93/pdf.worker.js`;
function FeedDetail() {
  const [loading, setLoading] = useState(true);
  const [post, setPost] = useState();
  const params = useParams();
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfData, setPdfData] = useState(null);
  const didMount = useRef(false);

  function onDocumentLoadSuccess(obj) {
    console.log(numPages);
    setNumPages(obj["_pdfInfo"]["numPages"]);
  }

  useEffect(() => {
    getPost();
  }, []);

  const getPost = async () => {
    const response = await fetch(apiEndPoint + "/api/posts/" + params.feedId);
    const json = await response.json();
    setPost(json);
    console.log(`${apiEndPoint + "/" + json["pdf_url"]}`);
    setLoading(false);
  };

  return loading ? (
    <MyLoading />
  ) : (
    <Box mt={10} borderWidth="1px" borderRadius="lg" p={5} boxShadow="sm">
      <Flex justifyContent="space-between" mb={2}>
        <Text fontSize="sm" color="gray.500">
          {new Date(post["created_on"]).toDateString()}
        </Text>
        <Button as="a" href={`${apiEndPoint + "/" + post["pdf_url"]}`} color={"brand.blue"} variant="solid" gap={2} alignItems={"center"}>
          <DownloadIcon /> <Text> Download PDF</Text>
        </Button>
      </Flex>

      <Text fontSize="xl" fontWeight="bold" mb={2}>
        {post["title"]}
      </Text>
      <Text fontSize="md" color="gray.600" mb={4}>
        {post["content"]}
      </Text>

      <Flex wrap="wrap" gap={2} mb={4}>
        {post["tags"].split(",").map((tag, index) => (
          <Tag key={index} colorScheme="blue">
            {tag}
          </Tag>
        ))}
      </Flex>
      <Center>
        {post ? (
          <Document
            loading={MyLoading}
            file={`${apiEndPoint + "/" + post["pdf_url"]}`}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            {Array.apply(null, Array(numPages))
              .map((x, i) => i + 1)
              .map((page) => (
                <Box shadow="lg" padding={5}>
                  <Page
                    pageNumber={page}
                    className="border-solid border-2 border-sky-500"
                    width={window.innerWidth * 0.95}
                  />
                </Box>
              ))}
          </Document>
        ) : (
          <MyLoading />
        )}
      </Center>
    </Box>
  );
}

export default FeedDetail;
